<template>
  <div>
    <v-toolbar flat color="white" class="hidden-sm-and-down">
      <v-toolbar-title>Kampanya Komisyonları</v-toolbar-title>
      <v-divider class="mx-3" inset vertical />
      <v-select
        v-model="selectedTenantId"
        :items="tenantOptions"
        item-text="tenantName"
        item-value="tenantId"
        label="Tenant Seç"
        style="min-width: 180px; margin-right: 12px; margin-top: 20px;"
        @change="onTenantChange"
      />
      <v-select
        v-model="selectedMpId"
        :items="marketplaceOptions"
        item-text="mpName"
        item-value="mpId"
        label="Pazaryeri Seç"
        style="min-width: 180px; margin-right: 12px; margin-top: 20px;"
        @change="onMarketplaceChange"
      />
      <v-btn color="primary" dark class="mb-2" @click="openCreateDialog">
        Yeni Ekle
      </v-btn>
      <v-spacer />
      <v-btn icon @click="refresh">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="tableItems"
      :loading="$store.state.progress"
      :rows-per-page-items="pageItems"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ getTenantName(props.item.tenantId) }}</td>
        <td class="px-0 text-xs-center">{{ getMarketplaceName(props.item.mpId) }}</td>
        <td class="px-0 text-xs-center">{{ formatDate(props.item.startDate) }}</td>
        <td class="px-0 text-xs-center">{{ props.item.commissionRate }}</td>
        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="refresh">Yenile</v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ isEdit ? 'Komisyonu Güncelle' : 'Yeni Komisyon' }}
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formIsValid">
            <v-select
              v-model="form.tenantId"
              :items="tenantOptions"
              item-text="tenantName"
              item-value="tenantId"
              label="Tenant"
              :rules="[v => !!v || 'Tenant zorunludur']"
            />
            <v-select
              v-model="form.mpId"
              :items="marketplaceOptions"
              item-text="mpName"
              item-value="mpId"
              label="Pazaryeri"
              :rules="[v => !!v || 'Pazaryeri zorunludur']"
            />
            <v-text-field
              v-model="form.campaignDate"
              label="Kampanya Tarihi"
              type="date"
              :rules="[v => !!v || 'Kampanya tarihi zorunludur']"
            />
            <v-text-field
              v-model.number="form.commissionRate"
              label="Komisyon Oranı (%)"
              type="number"
              step="0.01"
              :rules="[
                v => v !== null && v !== undefined || 'Komisyon oranı zorunludur',
                v => v >= 0 || 'Komisyon oranı negatif olamaz'
              ]"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeDialog">Vazgeç</v-btn>
          <v-btn color="primary" :disabled="!formIsValid" @click="save">
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { authenticationService } from '@/_services';

const DEFAULT_TENANT_OPTIONS = [
  { tenantId: 1, tenantName: 'Altinda Firsat' },
  { tenantId: 2, tenantName: 'EAltin' },
];

const DEFAULT_MARKETPLACES = [
  { mpId: 1, mpName: 'Hepsiburada' },
  { mpId: 2, mpName: 'Alışgidiş' },
  { mpId: 3, mpName: 'Trendyol' },
  { mpId: 4, mpName: 'Idefix' },
  { mpId: 5, mpName: 'Idia' },
];

export default {
  data() {
    return {
      dialog: false,
      isEdit: false,
      formIsValid: false,
      form: this.createEmptyForm(),
      selectedTenantId: null,
      selectedMpId: null,
      tenantOptions: DEFAULT_TENANT_OPTIONS,
      marketplaceOptions: DEFAULT_MARKETPLACES,
      headers: [
        { text: 'Tenant', value: 'tenantId' },
        { text: 'Pazaryeri', value: 'mpId' },
        { text: 'Kampanya Tarihi', value: 'startDate' },
        { text: 'Komisyon Oranı (%)', value: 'commissionRate' },
        { text: 'İşlem', value: 'actions', sortable: false },
      ],
      pageItems: [
        25,
        50,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
      ],
    };
  },
  computed: {
    tableItems() {
      return this.$store.state.campaignCommissions.all || [];
    },
  },
  created() {
    this.initializeSelectors();
  },
  beforeDestroy() {
    this.$store.dispatch('campaignCommissions/clearCampaignCommissions');
  },
  methods: {
    createEmptyForm() {
      return {
        id: null,
        tenantId: null,
        mpId: null,
        campaignDate: this.getTodayDate(),
        commissionRate: null,
      };
    },
    initializeSelectors() {
      const currentUser = authenticationService.currentUserValue;

      if (currentUser) {
        if (currentUser.tenantOptions && currentUser.tenantOptions.length > 0) {
          this.tenantOptions = currentUser.tenantOptions;
        }
        if (currentUser.marketplaceOptions && currentUser.marketplaceOptions.length > 0) {
          this.marketplaceOptions = currentUser.marketplaceOptions;
        }
      }

      const savedTenant = localStorage.getItem('selectedTenantId');
      const savedMp = localStorage.getItem('selectedMpId');

      const firstTenant = this.tenantOptions && this.tenantOptions.length > 0 ? this.tenantOptions[0].tenantId : null;
      const firstMarketplace = this.marketplaceOptions && this.marketplaceOptions.length > 0 ? this.marketplaceOptions[0].mpId : null;

      this.selectedTenantId = savedTenant ? parseInt(savedTenant, 10) : firstTenant;
      this.selectedMpId = savedMp ? parseInt(savedMp, 10) : firstMarketplace;

      if (this.selectedTenantId && this.selectedMpId) {
        this.refresh();
      }
    },
    async refresh() {
      if (!this.selectedTenantId || !this.selectedMpId) {
        this.$store.dispatch('campaignCommissions/clearCampaignCommissions');
        return;
      }

      await this.$store.dispatch('campaignCommissions/fetchCampaignCommissions', {
        tenantId: this.selectedTenantId,
        mpId: this.selectedMpId,
      });
    },
    onTenantChange() {
      if (this.selectedTenantId) {
        localStorage.setItem('selectedTenantId', this.selectedTenantId.toString());
      }
      this.refresh();
    },
    onMarketplaceChange() {
      if (this.selectedMpId) {
        localStorage.setItem('selectedMpId', this.selectedMpId.toString());
      }
      this.refresh();
    },
    openCreateDialog() {
      this.isEdit = false;
      this.form = this.createEmptyForm();
      this.form.tenantId = this.selectedTenantId;
      this.form.mpId = this.selectedMpId;
      this.dialog = true;
    },
    editItem(item) {
      this.isEdit = true;
      this.form = {
        id: item.id,
        tenantId: item.tenantId,
        mpId: item.mpId,
        campaignDate: this.toDateInputValue(item.startDate),
        commissionRate: item.commissionRate,
      };
      this.dialog = true;
    },
    async deleteItem(item) {
      if (!confirm('Silmek istediğinize emin misiniz?')) {
        return;
      }

      await this.$store.dispatch('campaignCommissions/deleteCampaignCommission', item.id);
      await this.refresh();
    },
    closeDialog() {
      this.dialog = false;
      this.form = this.createEmptyForm();
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    async save() {
      if (!(await this.$refs.form.validate())) {
        return;
      }

      var dateStr = this.form.campaignDate;
      var payload = {
        tenantId: this.form.tenantId,
        mpId: this.form.mpId,
        startDate: dateStr + 'T00:00:00',
        endDate: dateStr + 'T23:59:59',
        commissionRate: Number(this.form.commissionRate),
      };

      if (this.isEdit && this.form.id) {
        payload.id = this.form.id;
        await this.$store.dispatch('campaignCommissions/updateCampaignCommission', payload);
      } else {
        await this.$store.dispatch('campaignCommissions/createCampaignCommission', payload);
      }

      this.closeDialog();
      await this.refresh();
    },
    getTenantName(tenantId) {
      const match = Array.isArray(this.tenantOptions)
        ? this.tenantOptions.find((x) => x.tenantId === tenantId)
        : null;
      return match ? match.tenantName : tenantId;
    },
    getMarketplaceName(mpId) {
      const match = Array.isArray(this.marketplaceOptions)
        ? this.marketplaceOptions.find((x) => x.mpId === mpId)
        : null;
      return match ? match.mpName : mpId;
    },
    formatDate(value) {
      if (!value) {
        return '';
      }
      var date = new Date(value);
      var day = String(date.getDate()).padStart(2, '0');
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var year = date.getFullYear();
      return day + '.' + month + '.' + year;
    },
    getTodayDate() {
      var now = new Date();
      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
    toDateInputValue(value) {
      if (!value) {
        return null;
      }
      var date = new Date(value);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
  },
};
</script>
